import { IdentityService } from '../../account/identity/IdentityService';
import { Identity } from '../../account/identity/Identity';
import { AuthenticatedPrincipal } from '../../AuthenticatedPrincipal';
import { amorphicStatic, property, supertypeClass, Supertype } from '@haventech/amorphic';
import { LoggerSingleton, Category } from '../../logger/LoggerSingleton';

@supertypeClass({ toClient: true, toServer: false })
export class AMCIdentityCreator extends Supertype {
  @property({ toClient: false, getType: () => IdentityService })
  private identityService: IdentityService;

  static new(identityService: IdentityService): AMCIdentityCreator {
    return new AMCIdentityCreator().init(identityService);
  }

  init(identityService: IdentityService): AMCIdentityCreator {
    this.identityService = identityService;
    return this;
  }

  public async createOrGetAuth0Identity(auth0Id: string, principal: AuthenticatedPrincipal): Promise<Identity> {
    let identity: Identity = await this.identityService.loadIdentityByIdentifier(auth0Id);
    if (!identity) {
      identity = await this.identityService.createNewIdentity(auth0Id, true, undefined);

      LoggerSingleton.getInstance().info(
        {
          module: 'AMCIdentityCreator',
          function: 'createOrGetAuth0Identity',

          data: {
            identifier: auth0Id,
          },
        },
        'Created new Auth0 identity for customer'
      );
    }
    await this.identityService.associateApplicationWithIdentity(principal, identity);
    return identity;
  }

  public async createAMCIdentityIfNeeded(amcId: string, auth0Identity: Identity): Promise<void> {
    const amcIdentity: Identity = await this.identityService.loadIdentityByIdentifier(amcId);
    if (!amcIdentity && auth0Identity && auth0Identity.account) {
      await this.identityService.createNewIdentityForAccount(amcId, auth0Identity.account, false);

      LoggerSingleton.getInstance().info(
        {
          module: 'AMCIdentityCreator',
          function: 'createAMCIdentityIfNeeded',
          category: Category.request,

          data: {
            identifier: amcId,
          },
        },
        'Created AMC identity for customer and associated it with their Auth0 identity'
      );
    }
  }
}
